import React from "react";
import styled from "styled-components";
import { Button } from "antd";
import { device } from "../lib/breakpoints";

const EmptyState = ({
  icon,
  title,
  description,
  ctaLabel,
  ctaAction,
  ctaIcon,
  size = "large",
}) => {
  return (
    <Container>
      <IconContainer>{icon}</IconContainer>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
      {ctaLabel && ctaAction && (
        <CTAButton
          type="primary"
          size={size}
          icon={ctaIcon}
          onClick={ctaAction}
        >
          {ctaLabel}
        </CTAButton>
      )}
    </Container>
  );
};

export default EmptyState;

const Container = styled.div`
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--color-text-light);

  @media ${device.mobile} {
    padding: 1.5rem 1rem;
  }
`;

const IconContainer = styled.div`
  font-size: 3rem;
  margin-bottom: 0.75rem;
  opacity: 0.6;
  color: var(--color-text-muted);

  @media ${device.mobile} {
    font-size: 2.5rem;
  }
`;

const Title = styled.h3`
  margin: 0.75rem 0 0.5rem 0;
  font-family: var(--font-primary);
  color: var(--color-text);
  font-size: 1.25rem;
  font-weight: 600;

  @media ${device.mobile} {
    font-size: 1.1rem;
  }
`;

const Description = styled.p`
  margin: 0 0 1rem 0;
  font-family: var(--font-secondary);
  color: var(--color-text-light);
  font-size: 1rem;
  line-height: 1.5;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;

  @media ${device.mobile} {
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
  }
`;

const CTAButton = styled(Button)`
  &&.ant-btn.ant-btn-primary {
    background: var(--color-primary) !important;
    border: 1px solid var(--color-primary) !important;
    color: #ffffff !important;
    border-radius: 12px !important;
    height: 48px !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
    font-family: var(--font-secondary) !important;
    padding: 0 2rem !important;
    min-width: 200px !important;
    box-shadow: 0 4px 12px rgba(44, 95, 45, 0.2) !important;
    transition: all 0.3s ease !important;
  }

  &&.ant-btn.ant-btn-primary span,
  &&.ant-btn.ant-btn-primary .ant-btn-icon {
    color: #ffffff !important;
  }

  &&.ant-btn.ant-btn-primary .anticon {
    color: #ffffff !important;
  }

  &&.ant-btn.ant-btn-primary .anticon svg {
    fill: currentColor !important;
  }

  &&.ant-btn.ant-btn-primary:hover,
  &&.ant-btn.ant-btn-primary:focus {
    background: var(--color-primary-dark) !important;
    border-color: var(--color-primary-dark) !important;
    color: #ffffff !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 16px rgba(44, 95, 45, 0.3) !important;
  }

  &&.ant-btn.ant-btn-primary:hover span,
  &&.ant-btn.ant-btn-primary:focus span,
  &&.ant-btn.ant-btn-primary:hover .ant-btn-icon,
  &&.ant-btn.ant-btn-primary:focus .ant-btn-icon,
  &&.ant-btn.ant-btn-primary:hover .anticon {
    color: #ffffff !important;
  }

  &&.ant-btn.ant-btn-primary:active {
    transform: translateY(0) !important;
    color: #ffffff !important;
  }

  @media ${device.mobile} {
    &&.ant-btn.ant-btn-primary {
      height: 44px !important;
      font-size: 0.9rem !important;
      padding: 0 1.5rem !important;
      min-width: auto !important;
      width: 100% !important;
    }
  }
`;
